import { assertArray } from '@app/core/utilities/array.utilities';
import { CustomerApiService } from '@app/core/api/customer-api.service';
import { ApiRoute, CriterionAdditionApiRoute, CustomerApiRoute } from '@app/core/models/api.models';

export abstract class CriterionAdditionApiService extends CustomerApiService {
  override readonly customerRoute = CustomerApiRoute.CriterionAddition;

  abstract criterionAdditionRoute: CriterionAdditionApiRoute;

  protected get apiRoute(): ApiRoute {
    return [...assertArray(super.apiRoute), this.criterionAdditionRoute];
  }
}
